<template>
  <nav
    class="fixed inset-x-0 bottom-0 z-40 border-t border-[var(--ui-border)] bg-[var(--ui-bg)]/95 backdrop-blur lg:hidden"
    style="padding-bottom: env(safe-area-inset-bottom)"
    aria-label="ناوبری موبایل"
  >
    <ul class="grid" :style="{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }">
      <li
        v-for="item in items"
        :key="item.to"
      >
        <NuxtLink
          :to="item.to"
          class="flex flex-col items-center gap-1 px-1 py-2.5 text-[11px] no-underline"
          :class="isActive(item.to)
            ? 'font-semibold text-primary'
            : 'text-[var(--ui-text-muted)]'"
        >
          <span class="relative">
            <UIcon
              :name="item.icon"
              class="size-5"
            />
            <UBadge
              v-if="item.badge"
              color="primary"
              size="xs"
              class="absolute -end-2.5 -top-1.5 min-w-4 px-1"
            >
              {{ item.badge }}
            </UBadge>
          </span>
          <span class="truncate">{{ item.label }}</span>
        </NuxtLink>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
export interface MobileTabItem {
  label: string
  icon: string
  to: string
  badge?: string
}

const props = defineProps<{
  items: MobileTabItem[]
}>()

const route = useRoute()

function isActive(to: string) {
  if (to === '/' || to === '/dashboard' || to === '/admin' || to === '/support') {
    return route.path === to
  }
  // Booking and virtual-visits share a URL prefix; keep highlight exclusive.
  if (to === '/dashboard/booking') {
    const path = route.path
    return path === to || (path.startsWith(`${to}/`) && !path.startsWith('/dashboard/booking/virtual-visits'))
  }
  return route.path === to || route.path.startsWith(`${to}/`)
}
</script>
